import React from "react";

import i18next from "external/i18n";

export const ActualClaimContent = () => (
  <>
    <p>{i18next.t("help.claim.page.content.paragraph")}</p>
  </>
);
